import _ from 'lodash'
import constants from 'scoreboard/components/constants'
import EmailValidator from 'scoreboard/components/validators/email-validator'
import arrayToHash from 'scoreboard/components/array-to-hash'
import i18n from './i18n'

const WHITESPACE_OR_LINEBREAK = /(\s+|<br\/?>+)/gm
const TOP_LEVEL_DOMAINS = /[^\/]+\.([a-z]+)/i	//all valid tlds start with a letter
const HYPERTEXT_SCHEME = /(http|https):\/\//ig
const MAILTO_SCHEME = /mailto:/ig
// ensure global flag
const EMAIL = new RegExp(EmailValidator.regExp.source, 'ig')

let topLevelDomains = _.memoize(() => arrayToHash(constants.topLevelDomains))

/**
 * Parses texts for urls that potentially refer to websites and replaces the
 * plaintext URL with an HTML anchor with that url as it's href.
 *
 * @param text the plaintext to be parsed for links
 * @return {string}
 */
function urlsToLinks(text) {
	let parsed = ''

	//split by whitespace
	_.forEach(text.split(WHITESPACE_OR_LINEBREAK), token => {
		if (WHITESPACE_OR_LINEBREAK.test(token)) {
			parsed += token
		} else {
			let href = null
			let emailMatches = getEmailMatches(token)

			//check if ends with a valid domain (we're only focusing on valid hostnames)
			let domainTest = token.match(TOP_LEVEL_DOMAINS) || []
			let domains = topLevelDomains()

			//check if email first, since these can look like a website
			if (!_.isEmpty(emailMatches)) {
				//append scheme if necessary
				href = createEmailLink(emailMatches[0])
			} else if (!_.isEmpty(domainTest) && domains[domainTest[1].toUpperCase()] != null) {
				href = token.match(HYPERTEXT_SCHEME) ? token : 'http://'+token
			}
			if (href) {
				parsed += createAnchor(href, token)
			} else {
				parsed += token
			}
		}
	})
	return parsed
}

const getEmailMatches = (text) => {
	//check if token is an email address
	return text.replace(MAILTO_SCHEME, '').match(EMAIL) || []
}

const createEmailLink = (anEmail) => {
	return `mailto:${anEmail}`
}

const createAnchor = (href, labelOrMsgKey, target='_blank') => {
	return `<a class="text-link" target="${target}" href="${href}">${i18n.getWithoutTerminologyChanges(labelOrMsgKey)}</a>`
}

export default urlsToLinks
export { getEmailMatches }
export { createEmailLink }
export { createAnchor }

urlsToLinks.__filename__ = 'components/urls-to-links.js'
